import React from 'react';

export default function NeonSunglassesSvg({ size = 40, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" className={className}>
      <polygon points="30.94,25.47 2.0,25.47 2.0,12.81 30.94,12.81" fill="#705B49" />
      <polygon points="9.06,27.19 2.0,23.66 2.0,18.24 9.06,21.76" fill="#322820" opacity="0.95" />
      <polygon points="38.0,27.19 30.94,23.66 30.94,18.24 38.0,21.76" fill="#322820" opacity="0.95" />
    </svg>
  );
}
